/**
 * Central i18n setup using react-i18next.
 * Translations are in src/locales/{en,de,fr,es}.json.
 * Language is persisted in localStorage key "sbiLanguage".
 */

import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import en from "./locales/en.json";
import de from "./locales/de.json";
import fr from "./locales/fr.json";
import es from "./locales/es.json";

const STORAGE_KEY = "sbiLanguage";
const SUPPORTED_LANGS = ["en", "de", "fr", "es"];

function getInitialLanguage() {
  if (typeof window === "undefined") return "en";
  const stored = window.localStorage.getItem(STORAGE_KEY);
  if (stored && SUPPORTED_LANGS.includes(stored)) return stored;
  const browser = window.navigator.language
    ? window.navigator.language.slice(0, 2).toLowerCase()
    : null;
  if (browser && SUPPORTED_LANGS.includes(browser)) return browser;
  return "en";
}

i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en },
    de: { translation: de },
    fr: { translation: fr },
    es: { translation: es },
  },
  lng: getInitialLanguage(),
  fallbackLng: "en",
  interpolation: {
    escapeValue: false,
  },
});

i18n.on("languageChanged", (lng) => {
  if (typeof window !== "undefined") {
    window.localStorage.setItem(STORAGE_KEY, lng);
  }
});

export default i18n;
